import { SERVICE_PLAN_ITEMS_METRICS } from 'src/features/servicePlanItems/utils/types';
import { servicePlanItemsMessages } from 'src/features/servicePlanItems/utils/messages';
import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';

export const METRIC_TRANSACTIONS_MAP: Record<SERVICE_PLAN_ITEMS_METRICS, { id: string, defaultMessage: string }> = {
    [SERVICE_PLAN_ITEMS_METRICS.SEATS]: servicePlanItemsMessages.seats,
    [SERVICE_PLAN_ITEMS_METRICS.UNIT]: servicePlanItemsMessages.unit,
    [SERVICE_PLAN_ITEMS_METRICS.API_CALLS]: servicePlanItemsMessages.apiCalls,
    [SERVICE_PLAN_ITEMS_METRICS.GB]: servicePlanItemsMessages.gb,
    [SERVICE_PLAN_ITEMS_METRICS.CALLS]: servicePlanItemsMessages.calls,
    [SERVICE_PLAN_ITEMS_METRICS.DEVICES]: servicePlanItemsMessages.devices,
}


export const METRIC_BADGE_OPTIONS: Record<SERVICE_PLAN_ITEMS_METRICS, BadgeOption> = {
    [SERVICE_PLAN_ITEMS_METRICS.SEATS]: {
        label: servicePlanItemsMessages.seats,
        theme: 'orange',
        icon: ICON_MAP.SEATS,
    },
    [SERVICE_PLAN_ITEMS_METRICS.UNIT]: {
        label: servicePlanItemsMessages.unit,
        theme: 'green',
        icon: ICON_MAP.UNITS,
    },
    [SERVICE_PLAN_ITEMS_METRICS.API_CALLS]: {
        label: servicePlanItemsMessages.apiCalls,
        theme: 'indigo',
        icon: ICON_MAP.API_CALLS,
    },
    [SERVICE_PLAN_ITEMS_METRICS.GB]: {
        label: servicePlanItemsMessages.gb,
        theme: 'pink',
        icon: ICON_MAP.STORAGE,
    },
    [SERVICE_PLAN_ITEMS_METRICS.CALLS]: {
        label: servicePlanItemsMessages.calls,
        theme: 'cyan',
        icon: ICON_MAP.CALLS,
    },
    [SERVICE_PLAN_ITEMS_METRICS.DEVICES]: {
        label: servicePlanItemsMessages.devices,
        theme: 'sky',
        icon: ICON_MAP.DEVICES,
    },
}